import React from 'react'
import { notEmpty } from 'helpers/validators'
import { Row, Col } from 'react-flexbox-grid'
import { useTranslation } from 'react-i18next'
import get from 'lodash/get'

import ContentBlock from 'components/ContentBlock'
import { Form, Text, Select } from 'components/forms'
import ClientSelector from 'components/forms/ClientSelector'
import { useQuery } from 'components/graphql'
import getPriceLevels from 'config/localServer/query/priceLevelsQuery'

const GeneralParams = ({ formData, mutations: { updateItem } }) => {
	const [t] = useTranslation()
	const { data, queryField } = useQuery(getPriceLevels)
	const priceNames = get(data, [queryField], [])
	const priceOptions = [t('common.strings.none'), ...priceNames].map((name, i) => ({ value: i, label: name }))

	return(
		<ContentBlock>
			<Form
				smartSubmit
				initialValues={formData}
				onSubmit={updateItem}
			>
				<Row>
					<Col xs={5}>
						<ClientSelector lastNode='SHOP' field='shopId' {...notEmpty()}/>
						<Text field='name' label={t('options_section.fields.cash_register_name')} {...notEmpty()}/>
					</Col>
					<Col xs={5}>
						<Select
							field='priceLevelOut'
							label={t('options_section.fields.price_level')}
							options={priceOptions}
						/>
						<Select
							field='priceLevelIn'
							label={t('options_section.fields.price_level_in_house')}
							options={priceOptions}
						/>
						<Select
							field='mode'
							label={t('options_section.fields.mode')}
							options={[
								{ value: 0, label: `<${t('options_section.strings.standard')}>` },
								{ value: 100, label: t('common.strings.vat_normal') }
							]}
						/>
					</Col>
				</Row>
			</Form>
		</ContentBlock>
	)
}

export default GeneralParams
